import { yes, no } from '../constants/form-controls';

export function convertBooleanToRadio(checked: boolean) {
    return checked === true ? yes : no;
}